// assets/custom-quick-add.js
document.addEventListener('DOMContentLoaded', () => {
  const getCart = () => fetch('/cart.js').then(r => r.json());
  const toast  = document.getElementById('CustomNotification');
  const text   = document.getElementById('NotificationText');
  const image  = document.getElementById('NotificationImage');

  function updateHeaderBadge(count) {
  // 1) найдём контейнер
  const bubble = document.querySelector('.cart-count-bubble');
  if (!bubble) return;

  // 2) если был класс hidden — убираем его
  bubble.classList.remove('hidden');

  // 3) обновляем цифру
  const badge = bubble.querySelector('#HeaderCartCount');
  if (badge) badge.textContent = count;
}

  // Текущее число товаров из бейджа — для оптимистичного обновления счётчика
  // без дополнительного запроса /cart.js.
  function currentBadgeCount() {
    const badge = document.querySelector('.cart-count-bubble #HeaderCartCount');
    const n = parseInt(badge && badge.textContent, 10);
    return Number.isFinite(n) ? n : 0;
  }


  function openCartDrawer() {
    const toggle = document.getElementById('CartToggle')
      || document.querySelector('button[aria-controls="CartDrawer"]')
      || document.querySelector('[data-cart-toggle]');
    if (toggle) toggle.click();
  }

  if (toast) {
    toast.addEventListener('click', () => {
      clearTimeout(toast._timer);
      toast.classList.remove('visible');
      toast.classList.add('hidden');
      openCartDrawer();
    });
  }

  document.querySelectorAll('product-form').forEach(el => {
    const form = el.querySelector('form');
    if (!form) return;

    form.addEventListener('submit', async e => {
      e.preventDefault();

      const btn     = form.querySelector('button[type="submit"]');
      const spinner = btn.querySelector('.loading__spinner') || btn.querySelector('.spinner');

      // 1) Включаем спиннер и блокируем кнопку
      btn.classList.add('loading');
      btn.setAttribute('disabled', 'disabled');         // атрибут
      btn.setAttribute('aria-disabled', 'true');        // на всякий случай
      if (spinner) spinner.classList.remove('hidden');

      // 2) Собираем данные
      const fd   = new FormData(form);
      const id   = fd.get('id');
      const qty  = fd.get('quantity') || 1;

      try {
        // 3) AJAX-добавление (единственный сетевой запрос в горячем пути)
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: +id, quantity: +qty })
        });
        if (!res.ok) throw new Error('Add failed');
        const item = await res.json();

        // 4) Оптимистично обновляем счётчик из ответа — без второго запроса
        //    /cart.js (он и был источником ~секундной задержки).
        const addedQty = Number(item.quantity) || Number(qty) || 1;
        updateHeaderBadge(currentBadgeCount() + addedQty);

        // 5) Показываем навигацию и держим её, пока висит toast.
        //    preventHide не даёт sticky-header спрятаться на скролле вниз.
        const stickyEl = document.querySelector('sticky-header');
        if (stickyEl && typeof stickyEl.reveal === 'function') {
          stickyEl.preventHide = true;
          stickyEl.reveal();
        } else {
          const hdr = document.querySelector('.section-header');
          if (hdr) {
            hdr.classList.add('shopify-section-header-sticky', 'animate');
            hdr.classList.remove('shopify-section-header-hidden');
          }
        }

        // 6) Показываем ваш toast
        const imageUrl = item.featured_image?.url || item.image || '';

        text.textContent = item.product_title || item.title || '';
        if (image) {
          image.hidden = !imageUrl;
          image.src = imageUrl;
        }
        toast.classList.toggle('has-image', Boolean(imageUrl));
        toast.classList.remove('hidden');
        toast.classList.add('visible');

        // Функция скрытия: убираем toast и возвращаем обычное поведение хедера
        // (он снова сможет прятаться при скролле вниз).
        function hideToast() {
          toast.classList.remove('visible');
          toast.classList.add('hidden');
          if (stickyEl) stickyEl.preventHide = false;
        }

        // Держим toast + навигацию ~2000 мс.
        clearTimeout(toast._timer);
        toast._timer = setTimeout(hideToast, 2000);


      } catch (err) {
        console.error(err);
        // здесь при желании можно вывести уведомление об ошибке
      } finally {
        // 7) В любом случае снимаем спиннер и разблокируем кнопку
        btn.classList.remove('loading');
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      }
    });
  });

  
});
